/**
 * WVB-01 — Shared config and utilities for Event Graph components
 */

// Node type display config
export const NODE_CONFIG = {
  EVENT_MASTER:       { label: "Event",      bg: "#eef2ff", border: "#c7d2fe", text: "#3730a3" },
  OPPORTUNITY:        { label: "Opp",        bg: "#f5f3ff", border: "#ddd6fe", text: "#6d28d9" },
  BOOKING:            { label: "Booking",    bg: "#f0f0ff", border: "#c7d2fe", text: "#4338ca" },
  LEAD:               { label: "Lead",       bg: "#f8fafc", border: "#e2e8f0", text: "#475569" },
  ACCOUNT:            { label: "Account",    bg: "#f8fafc", border: "#e2e8f0", text: "#334155" },
  EVENT_FUNCTION:     { label: "Function",   bg: "#f0fdfa", border: "#99f6e4", text: "#0f766e" },
  EXECUTION_STREAM:   { label: "Stream",     bg: "#eff6ff", border: "#bfdbfe", text: "#1d4ed8" },
  STREAM_MEMBER:      { label: "Member",     bg: "#f0f9ff", border: "#bae6fd", text: "#0369a1" },
  MILESTONE:          { label: "Milestone",  bg: "#fffbeb", border: "#fde68a", text: "#b45309" },
  TASK:               { label: "Task",       bg: "#fff7ed", border: "#fed7aa", text: "#c2410c" },
  SCOPE_LINE:         { label: "Scope",      bg: "#f0fdf4", border: "#bbf7d0", text: "#15803d" },
  PARTNER_ASSIGNMENT: { label: "Partner",    bg: "#ecfdf5", border: "#a7f3d0", text: "#047857" },
  READINESS_ITEM:     { label: "Readiness",  bg: "#fefce8", border: "#fef08a", text: "#a16207" },
  ISSUE:              { label: "Issue",      bg: "#fef2f2", border: "#fecaca", text: "#b91c1c" },
  DOCUMENT:           { label: "Document",   bg: "#fafaf9", border: "#e7e5e4", text: "#57534e" },
};

// Depth level for visual graph layout
export const NODE_DEPTH = {
  ACCOUNT: 0, LEAD: 0,
  OPPORTUNITY: 1,
  BOOKING: 2,
  EVENT_MASTER: 3,
  EVENT_FUNCTION: 4, SCOPE_LINE: 4, READINESS_ITEM: 4, ISSUE: 4,
  EXECUTION_STREAM: 5, MILESTONE: 5, PARTNER_ASSIGNMENT: 5,
  STREAM_MEMBER: 6, TASK: 6,
  DOCUMENT: 7,
};

// Navigation targets for click-through
export function navTarget(nodeType, nodeId) {
  switch (nodeType) {
    case "OPPORTUNITY": return `/crm/opportunities/${nodeId}`;
    case "LEAD":        return `/engage/leads/${nodeId}`;
    case "BOOKING":     return `/crm/bookings/${nodeId}`;
    default:            return null;
  }
}

// Edge style per edge type
export const UPSTREAM_TYPES = new Set([
  "ORIGINATED_FROM", "OWNED_BY_ACCOUNT", "BOOKED_UNDER", "EVENT_FOR"
]);

// Status pill styles
export const STATUS_STYLES = {
  CONFIRMED:   "bg-indigo-50 text-indigo-700",
  PLANNING:    "bg-amber-50 text-amber-700",
  LIVE:        "bg-emerald-50 text-emerald-700",
  COMPLETED:   "bg-slate-100 text-slate-500",
  CLOSED:      "bg-slate-100 text-slate-400",
  CANCELLED:   "bg-red-50 text-red-500",
  OPEN:        "bg-red-50 text-red-600",
  RESOLVED:    "bg-emerald-50 text-emerald-600",
  READY:       "bg-green-50 text-green-600",
  PENDING:     "bg-amber-50 text-amber-600",
  TODO:        "bg-slate-50 text-slate-500",
  IN_PROGRESS: "bg-blue-50 text-blue-600",
  APPROVED:    "bg-green-50 text-green-700",
  DRAFT:       "bg-slate-50 text-slate-500",
};
